import { useAppSelector } from 'store/hooks.ts';
import { jwtTokenSelector, userIDSelector } from 'store/feature/authToken/authToken.selector.ts';

export type DmaTableAuth = {
  accessToken: string;
  userId: number;
};

/**
 * Credential for a `PalmettoReactTable` whose `dataUrl` points at the DMA API.
 *
 * *: The table builds its own request inside `@zawarski/palmetto-direflow-react-table`
 * *: rather than going through `apiFetch`, and puts `auth.accessToken` on the raw
 * *: `Authorization` header. The DMA API Gateway `COGNITO_USER_POOLS` authorizer
 * *: accepts only the Cognito ID token (`authToken.jwtToken`), so a grid that reaches
 * *: for `selectAuthToken` -- the legacy Palmetto portal credential the report-export
 * *: documents backend still needs -- gets a 401 on every request.
 *
 * *: Reading the credential here rather than at each grid keeps that choice in one
 * *: place: the table's `auth` prop is handed a ready-made object with nothing left
 * *: to wire wrongly.
 */
function useDmaTableAuth(): DmaTableAuth {
  const jwtToken = useAppSelector(jwtTokenSelector);
  const userId = useAppSelector(userIDSelector);

  return { accessToken: jwtToken ?? '', userId: userId ?? 0 };
}

export default useDmaTableAuth;
